<form [formGroup]="rateDetailsForm" (ngSubmit)="isFormSubmitted = true;updateRateDetails()" (keydown.enter)="$event.preventDefault()">
    <div class="modal-dialog modal-dialog-centered detail-modal">
      <div class="modal-content">
        <div class="modal-header">
              <h4 class="modal-title">Rate Upload Info.</h4>
          <button type="button" class="btn-close" aria-label="Close"
          (click)="activeModal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body">
          <div class="card">
            <div class="card-body">
                <div class="row mb-2">
                    <div class="card-header bg-transparent border-bottom text-uppercase">Origin</div>
                    <div class="col-md-3 mt-1">
                        <div class="mb-2">
                            <label for="country" class="form-label">Country</label>
                            <ng-select id="country" formControlName="ddlOriginCountry" placeholder="Select"
                                [items]="countryList" bindLabel="name" [bindValue]="'code'" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                (change)="onOriginCountryChange()"  />
                        </div>
                    </div>
                    <div class="col-md-3 mt-1">
                        <div class="mb-2">
                            <label for="state" class="form-label">State</label>
                            <ng-select id="state" formControlName="ddlOriginState" placeholder="Select"
                                [items]="originStateList" bindLabel="name" [bindValue]="'code'" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                (change)="onOriginStateChange()"  />
                        </div>
                    </div>
                    <div class="col-md-3 mt-1">
                        <div class="mb-2">
                            <label for="city" class="form-label">City</label>
                            <ng-select id="city" formControlName="ddlOriginCity" placeholder="Select"
                                [items]="originCityList" bindLabel="name" [bindValue]="'code'" [appendTo]="'ngb-modal-window'" [openOnEnter]="false" />
                        </div>
                    </div>
                </div>
                <div class="row mt-4 mb-4">
                    <div class="card-header bg-transparent border-bottom text-uppercase">Destination</div>
                    <div class="col-md-3 mt-1">
                        <div class="mb-2">
                            <label for="country" class="form-label">Country</label>
                            <ng-select id="country" formControlName="ddlDestinationCountry"
                                placeholder="Select" [items]="countryList" bindLabel="name" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                [bindValue]="'code'" (change)="onDestinationCountryChange()"  />
                        </div>
                    </div>
                    <div class="col-md-3 mt-1">
                        <div class="mb-2">
                            <label for="state" class="form-label">State</label>
                            <ng-select id="state" formControlName="ddlDestinationState" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                [items]="destinationStateList" bindLabel="name" [bindValue]="'code'"
                                (change)="onDestinationStateChange()"  />
                        </div>
                    </div>
                    <div class="col-md-3 mt-1">
                        <div class="mb-2">
                            <label for="city" class="form-label">City</label>
                            <ng-select id="city" formControlName="ddlDestinationCity" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                [items]="destinationCityList" bindLabel="name" [bindValue]="'code'"  />
                        </div>
                    </div>
                </div>
                <div class="row mt-5 mb-4">
                    <div class="col-md-3">
                        <div class="mb-2">
                            <label for="product" class="form-label">Product</label>
                            <ng-select id="product" formControlName="ddlProduct" placeholder="Select"
                                [items]="productList" bindLabel="name" [bindValue]="'code'" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"  >
                                <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                                    <span>{{ item.name }}</span>
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="mb-2">
                            <label for="formVendor" class="form-label">Vendor</label>
                            <ng-select id="formVendor" formControlName="ddlVendor" placeholder="Select"
                                [items]="vendorList" bindLabel="name" [bindValue]="'code'" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                (change)="getAllVendorServices($event.id, true)"   >
                                <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                                    <span>{{ item.name }}</span>
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="mb-2">
                            <label for="service" class="form-label">Service</label>
                            <ng-select id="service" formControlName="ddlService" placeholder="Select"
                                [items]="serviceList" bindLabel="servicename" [bindValue]="'servicename'" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"  >
                            </ng-select>
                            <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                                <span>{{ item.name }}</span>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="mb-2">
                            <label for="zone" class="form-label">Zone</label>
                            <ng-select id="zone" formControlName="ddlZone" placeholder="Select"
                                [items]="zoneList" bindLabel="zonecode" [bindValue]="'zonecode'" [appendTo]="'ngb-modal-window'" [openOnEnter]="false" />
                        </div>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-md-3">
                        <div class="mb-2">
                            <label for="ratType" class="form-label">Rate Type</label>
                            <ng-select id="ratType" formControlName="ddlCategory" placeholder="Select"
                                [items]="categoryList" bindLabel="category" [bindValue]="'category'" [appendTo]="'ngb-modal-window'" [openOnEnter]="false" />
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="mb-2">
                            <label for="weight" class="form-label">Weight<span
                                    class="mandatory">*</span></label>
                            <input type="number" formControlName="txtWeight"
                                class="form-control form-control-sm ng-untouched ng-pristine ng-valid"
                                ng-reflect-name="weight"
                                [ngClass]="{'is-invalid': (isFormSubmitted || rateDetailsForm.get('txtWeight')?.touched) && rateDetailsForm.get('txtWeight').errors}"  >
                            <div *ngIf="(isFormSubmitted || rateDetailsForm.get('txtWeight')?.touched) && rateDetailsForm.get('txtWeight').errors"
                                class="invalid-feedback">
                                <span *ngIf="rateDetailsForm.get('txtWeight').errors.required">Weight is
                                    Required</span>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-3">
                        <div class="mb-2">
                            <label for="rate" class="form-label">Rate<span
                                    class="mandatory">*</span></label>
                            <input id="rate" class="form-control form-control-sm" type="number"
                                formControlName="txtRate"
                                [ngClass]="{'is-invalid': (isFormSubmitted || rateDetailsForm.get('txtRate')?.touched) && rateDetailsForm.get('txtRate').errors}"  >
                            <div *ngIf="(isFormSubmitted || rateDetailsForm.get('txtRate')?.touched) && rateDetailsForm.get('txtRate').errors"
                                class="invalid-feedback">
                                <span *ngIf="rateDetailsForm.get('txtRate').errors.required">Rate is
                                    Required</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="updateRateDetails()">Update</button>
        </div>
      </div>
    </div>
</form>